import { CommonIcons, icons } from '../../components/common/CommonIcons';

const navConfig = [
  {
    title: 'dashboard',
    path: 'dashboard',
    icon: <CommonIcons name={icons.dashboard} />,
  },

  {
    title: 'people',
    path: '',
    icon: <CommonIcons name={icons.users} />,
    children: [
      {
        title: 'members',
        path: 'users/members',
        allowOpenNew: true,
      },
      {
        title: 'suppliers',
        path: 'users/suppliers',
        allowOpenNew: true,
      },
    ],
  },
  {
    title: 'products',
    path: '',
    icon: <CommonIcons name={icons.products} />,
    children: [
      {
        title: 'items',
        path: 'products',
      },
    ],
  },
  {
    title: 'sales',
    path: '',
    icon: <CommonIcons name={icons.sales} />,
    children: [
      {
        title: 'salesOrders',
        path: 'documents/salesOrders',
      },
      {
        title: 'retailCashSales',
        path: 'documents/retailCashSales',
      },
    ],
  },
  {
    title: 'purchases',
    path: '',
    icon: <CommonIcons name={icons.purchase} />,
    children: [
      {
        title: 'purchaseOrders',
        path: 'documents/purchaseOrders',
      },
      {
        title: 'purchaseReturns',
        path: 'documents/purchaseReturns',
      },
      {
        title: 'purchaseInvoices',
        path: 'documents/purchaseInvoices',
      },
    ],
  },
  {
    title: 'warehouse',
    path: '',
    icon: <CommonIcons name={icons.warehouse} />,
    children: [
      {
        title: 'itemReceives',
        path: 'documents/itemReceives',
      },
      {
        title: 'itemTransfers',
        path: 'documents/itemTransfers',
      },
      {
        title: 'itemRelocates',
        path: 'documents/itemRelocates',
      },
      {
        title: 'itemTransforms',
        path: 'documents/itemTransform',
      },
      {
        title: 'stockTakes',
        path: 'documents/stockTakes',
      },
      {
        title: 'transferReturns',
        path: 'documents/transferReturns',
      },
      {
        title: 'transferRequisitions',
        path: 'documents/transferRequisitions',
      },
    ],
  },
  {
    title: 'others',
    path: '',
    icon: <CommonIcons name={icons.documents} />,
    children: [
      {
        title: 'retailPrescriptions',
        path: 'documents/retailPrescriptions',
      },
    ],
  },
  {
    title: 'operations',
    path: '',
    icon: <CommonIcons name={icons.operations} />,
    children: [
      {
        title: 'examineInventory',
        path: 'inventory/viewInventory',
      },
    ],
  },
  // {
  //   title: 'Item Transfers',
  //   path: 'documents/itemTransfers',
  //   icon: systemIcons.itemTransfers,
  // },
  // {
  //   title: 'Item Adjustments',
  //   path: 'documents/itemAdjustments',
  //   icon: systemIcons.itemAdjustment,
  // },
  {
    title: 'reports',
    path: '',
    icon: <CommonIcons name={icons.report} />,
    children: [
      {
        title: 'warehouse',
        path: 'reports/warehouse/itemReceive',
        allowOpenNew: true,
      },
    ],
  },
  // {
  //   title: 'Examine Storage',
  //   path: 'inventory/examineStorage',
  //   icon: systemIcons.examineStorage,
  // },
  // {
  //   title: 'user',
  //   path: '/sample/user',
  //   icon: systemIcons.users,
  // },
  // {
  //   title: 'product',
  //   path: '/sample/products',
  //   icon: systemIcons.cart,
  // },
  // {
  //   title: 'blog',
  //   path: '/sample/blog',
  //   icon: systemIcons.blog,
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: systemIcon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: systemIcons.disabled,
  // },
];

export default navConfig;
